// extracted by mini-css-extract-plugin
module.exports = {"shapeIcon":"shapePicker_shapeIcon__nSNdk"};